import React from 'react';
import { FadeIn } from './FadeIn';
export function Mechanism() {
  return <section className="py-24 px-6 bg-cream" data-id="element-129">
      <div className="max-w-3xl mx-auto text-center" data-id="element-130">
        <FadeIn data-id="element-131">
          <span className="text-terracotta font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-132">
            La Solución
          </span>
          <h2 className="font-serif text-3xl md:text-5xl text-charcoal mb-8" data-id="element-133">
            El Método de Gestión del Cortisol
          </h2>
          <div className="space-y-6 font-sans text-lg text-charcoal/80 leading-relaxed text-left" data-id="element-134">
            <p data-id="element-135">
              La clave no es comer menos, es enviar la señal de "seguridad" a
              tus glándulas adrenales. Presentamos el Método de Gestión del
              Cortisol.
            </p>
            <p data-id="element-136">
              En lugar de restringir, reprogramamos. Al darle a tu cuerpo los
              nutrientes específicos y el descanso que necesita, el cortisol
              baja, el metabolismo se despierta y tu cuerpo finalmente se siente
              a salvo para soltar la grasa que ha estado reteniendo como
              protección.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}